import { render, staticRenderFns } from "./programmeAdvantage.vue?vue&type=template&id=61002cbc&"
import script from "./programmeAdvantage.vue?vue&type=script&lang=js&"
export * from "./programmeAdvantage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports